import { Component, Injector, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersCardViewComponent } from '../orders-card-view/orders-card-view.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-mobile-card-view',
    templateUrl: './mobile-card-view.component.html',
    styleUrls: ['./mobile-card-view.component.scss'],
    standalone: false
})
export class MobileCardViewComponent extends OrdersCardViewComponent {
  @Input() mobile_card_resource: any = {};
  statusResource:any
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
  ) {
    super(injector, router, route, modal);
  }

  ngOnInit(): void {
    // this.card_resource = this.mobile_card_resource;
    super.ngOnInit();
  }

  setFields(resourceDef) {
    super.setFields(resourceDef);
    if(this.footerResource && this.footerResource.actions && this.footerResource.actions.statusActions){
      this.setFields_status(this.footerResource.actions.statusActions)
    }
  }

  setFields_status(fields) {
    //uncomment to enable order by json 
    // let statusResource = this.validConditions(fields);
    // this.statusResource = statusResource.sort((a, b) => { return a.order - b.order });
    this.statusResource = this.validConditions_status(fields);
  }

  validConditions_status(fields) {
    if (fields) {
      fields.forEach(field => {
        if (field.statusConditions && field.statusConditions.length > 0) {
          let status = this.isExpressionValid__status(field.statusConditions);
          if (status == -1)
            field['status'] = true
          else
            field['status'] = false
        }
        else {
          field['status'] = true
        }

        if (field.fieldConditions && field.fieldConditions.length > 0) {
          let valid = this.isExpressionValid__status(field.fieldConditions);
          if (valid == -1)
            field['valid'] = true
          else
            field['valid'] = false
        }
        else {
          field['valid'] = true
        }
      })
    }
    return fields
  }

  isExpressionValid__status(conditions) {
    let result = [];
    let item = this.item
    conditions.forEach(exp => {
      result.push(eval(exp.expression))
    })
    return result.indexOf(false)
  }
  getRequestHistory(serviceRequestId){
    let data = {
      filter: "serviceRequestId:"+serviceRequestId
    }
  }

}
